import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'

import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'
import { questionPoolListQueryOptions } from '@/modules/question-pool/question-pool.hooks'

export const questionPoolRoute = createRoute({
  path: '/question-pools',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const questionPoolListRoute = createRoute({
  getParentRoute: () => questionPoolRoute,
  path: '/',
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'question_pool.list',
      'Soru havuzu listesine erişim izniniz yok.'
    ),
  loader: () => queryClient.ensureQueryData(questionPoolListQueryOptions()),
  head: () => ({ meta: [{ title: 'Soru Havuzları' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/question-pool/pages/list-question-pool.page')
  ),
})
